// Google OAuth Configuration
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

/**
 * Dynamically determines the redirect URI based on the current origin
 * This allows the same code to work across all environments without wildcards
 */
export const getRedirectURI = (): string => {
  // Get current origin (protocol + hostname + port)
  const origin = window.location.origin;

  // Build redirect URI with the callback path
  // Note: This works with or without language prefix in the URL
  return `${origin}/auth/google/callback`;
};

export const getGoogleOAuthUrl = (): string => {
  const redirectURI = getRedirectURI();

  const params = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: redirectURI,
    response_type: "code",
    scope: "openid profile email",
    access_type: "offline",
    prompt: "consent",
  });

  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
};

export const initiateGoogleOAuth = (): void => {
  window.location.href = getGoogleOAuthUrl();
};
